
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M250 .1c17.3 0 31.3 14 31.3 31.3v187.4h187.5c17.3 0 31.3 14 31.3 31.3s-14 31.3-31.3 31.3H281.3v187.4c0 17.3-14 31.3-31.3 31.3s-31.3-14-31.3-31.3V281.3H31.3C14 281.3 0 267.3 0 250s14-31.3 31.3-31.3h187.5V31.4C218.8 14.1 232.7.1 250 .1z"}})])
          )
        }
      }
    